import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { LANG_STORAGE_KEY, LANGS } from "@/lib/i18n";

const I18nContext = createContext({
  lang: "ru",
  setLang: () => {},
  cycle: () => {},
});

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState("ru");

  useEffect(() => {
    try {
      const saved = localStorage.getItem(LANG_STORAGE_KEY);
      if (saved && LANGS.includes(saved)) {
        setLangState(saved);
      }
    } catch (e) {
      /* ignore */
    }
  }, []);

  const setLang = useCallback((value) => {
    if (!LANGS.includes(value)) return;
    setLangState(value);
    try {
      localStorage.setItem(LANG_STORAGE_KEY, value);
    } catch (e) {
      /* ignore */
    }
  }, []);

  const cycle = useCallback(() => {
    const idx = LANGS.indexOf(lang);
    const next = LANGS[(idx + 1) % LANGS.length];
    setLang(next);
  }, [lang, setLang]);

  const value = useMemo(() => ({ lang, setLang, cycle }), [lang, setLang, cycle]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
